import React from 'react';

const NotesSection = ({ submission, jsonContent, isDark }) => {
    return (
        <div className={`rounded-[10px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] p-[20px] flex flex-col gap-[12px] d-none transition-colors duration-200 ${
            isDark ? 'bg-[#000000]' : 'bg-white'
        }`}>
            <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
            }`}>Notes</p>
            <textarea
                className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] resize-none transition-colors duration-200 ${
                    isDark 
                        ? 'bg-[#161515]  text-white' 
                        : 'bg-[#f5f5f5] text-[#072837]'
                }`}
                rows="5"
                value={submission.notes || jsonContent.notes || ''}
                readOnly
            />
        </div>
    );
};

export default NotesSection;
